import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { DsButtonVariants, Icons, DsTooltipPosition } from '@levelaccess/design-system';

import { chain } from 'lodash';
import { NavService } from '../../../../services/navigation/nav.service';
import { INavMenuItem, NavigationItem } from '../../../../services/navigation/nav-structure';
import { SharedCommonUtility } from '../../../../../../shared/utils/common.utility';
import { ExternalLinkService } from '../../../../services/external-link.service';

@Component({
  selector: 'top-navbar-control-hub-dropdown',
  templateUrl: './top-navbar-control-hub-dropdown.component.html',
})
export class TopNavbarControlHubDropdownComponent implements OnInit {
  public Icons: typeof Icons;
  public DsButtonVariants: typeof DsButtonVariants;
  public DsTooltipPosition: typeof DsTooltipPosition;

  public menuItems$: Observable<INavMenuItem[]>;
  public currentActiveMenuItem$: Observable<INavMenuItem>;

  constructor(
    private navService: NavService,
    private externalLinkService: ExternalLinkService,
  ) {
    this.Icons = Icons;
    this.DsButtonVariants = DsButtonVariants;
    this.DsTooltipPosition = DsTooltipPosition;
  }

  ngOnInit(): void {
    const navItems: NavigationItem[] = [
      NavigationItem.level_ci,
      NavigationItem.evaluations,
      NavigationItem.organization_settings,
      NavigationItem.tools_and_integrations,
      NavigationItem.administration,
      NavigationItem.internal_use_only,
    ];
    this.menuItems$ = this.navService.getTopLevelMenuItems$(navItems).pipe(
      map((items: INavMenuItem[]): INavMenuItem[] =>
        chain(items)
          .filter((item: INavMenuItem) => item?.isAvailable)
          .sortBy((item: INavMenuItem) => navItems.indexOf(item.id))
          .each((item: INavMenuItem) => {
            if (SharedCommonUtility.notNullish(item.externalLinkFn)) {
              item.routerLink = item.externalLinkFn(this.externalLinkService);
            }
          })
          .value(),
      ),
    );

    this.currentActiveMenuItem$ = this.navService.activeTopLevelMenuItem$();
  }
}
